import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'

const Gallery = ({
  badgeTitle,
  compatibilityStatus: {
    compatibilityType
  } = {},
  imageSetPath
}) =>
  <Wrapper>
    { badgeTitle &&
    <Badge>
      <BadgeText>{ badgeTitle }</BadgeText>
    </Badge> }
    <GalleryIframe title="Tire Image Gallery" src={ imageSetPath } />
  </Wrapper>

Gallery.propTypes = {
  badgeTitle: PropTypes.string,
  compatibilityStatus: PropTypes.shape({
    compatibilityType: PropTypes.bool
  }),
  imageSetPath: PropTypes.string
}

export default Gallery

const GalleryIframe = styled.iframe`
  min-width: 100%;
  width: 100%;
  height: 570px;
  border: none;
`

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  ${Mixin.responsive('margin', '0 0 20px', '0 0 10px')}
  ${Mixin.responsive('padding', '20px', '0 16px')}
`

const Badge = styled.div`
  width: 70px;
  height: 88px;
  position: absolute;
  margin-left: 10px;
  text-align: center;
  color: ${Theme.colors.white};
  display: table;
  word-spacing: 70px;
  background-color: ${Theme.colors.bright_red_new};
  z-index: 1;
  box-shadow: -3px 3px 4px 0 rgba(0, 0, 0, 0.25);

  &::after,
  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 29px;
    background-color: ${Theme.colors.bright_red_new};
    z-index: -1;
  }

  &::after {
    transform: skewY(-10deg);
  }

  &::before {
    transform: skewY(-170deg);
  }
`

const BadgeText = styled.span`
  ${Mixin.font.GothamBold(14)}
  display: table-cell;
  vertical-align: middle;

  &::before {
    content: '';
    position: absolute;
    display: block;
    border-style: solid;
    border: 9px solid;
    border-color: transparent  transparent ${Theme.colors.dark_red} transparent;
    border-right: transparent;
    top: -9px;
    left: -9px;
  }
`
